import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
// As we are using createAsynThunk, so we are writing our actions separately to provide them in extraReducers

export const getYardRowsSlotsAction = createAsyncThunk(
  "yard/getYardRowsSlotsAction", // action string
  async (id: number) => {
    try {
      const res = await ax.get<IApi>(`/get-yard-slots-details-by-yard-id/${id}?ShowIsActive=true`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getContainerYardRowsSlotsAction = createAsyncThunk(
  "yard/getContainerYardRowsSlotsAction", // action string
  async (id: number) => {
    try {
      const res = await ax.get<IApi>(
        `/get-container-yard-slots-details-by-yard-id/${id}?ShowIsActive=true&isContainerYard=true`
      );
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllYardsListingAction = createAsyncThunk(
  "yard/getAllYardsListingAction", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-all-yards");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getActiveAllYardsListingAction = createAsyncThunk(
  "yard/getActiveAllYardsListingAction", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-all-yards?ShowIsActive=true");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getActiveAllContainerYardsListingAction = createAsyncThunk(
  "yard/getActiveAllContainerYardsListingAction", // action string
  async () => {
    try {
      const res = await ax.get<IApi>(
        "/get-all-container-yards?ShowIsActive=true&isContainerYard=true"
      );
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllRowsByYardIdAction = createAsyncThunk(
  "yard/getAllRowsByYardIdAction", // action string
  async (id: any) => {
    try {
      const res = await ax.get<IApi>(`/get-yard-rows-by-yard-id/${id}?ShowIsActve=true`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getAllSlotsByRowIdAction = createAsyncThunk(
  "yard/getAllSlotsByRowIdAction", // action string
  async (id: any) => {
    try {
      const res = await ax.get<IApi>(`/get-yard-row-slots-by-yard-row-id/${id}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getAllAvailableSlotsByRowIdAction = createAsyncThunk(
  "yard/getAllAvailableSlotsByRowIdAction", // action string
  async (id: any) => {
    try {
      const res = await ax.get<IApi>(
        `/get-yard-row-slots-by-yard-row-id/${id}?showAvailableSlotsOnly=true`
      );
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getAllAvailableContainerSlotsByRowIdAction = createAsyncThunk(
  "yard/getAllAvailableContainerSlotsByRowIdAction", // action string
  async (id: any) => {
    try {
      const res = await ax.get<IApi>(
        `/get-yard-row-slots-by-yard-row-id/${id}?showAvailableSlotsOnly=true&IsContainerYard=true`
      );
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateYardSlotAction = createAsyncThunk(
  "configuration/updateYardSlotAction",
  async (formRecord: any) => {
    try {
      const res = await ax.put<IApi>("/update-yard-slot", formRecord);
      if (res.data.isSuccess === true && res.data.value.isUpdated === true)
        return res.data.value.isUpdated;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getYardTrail = createAsyncThunk(
  "yard/getYardTrail", // action string
  async (id: any) => {
    try {
      const res = await ax.get<IApi>(`/get-yard-trail-by-reg-num/${id}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getContainerYardTrail = createAsyncThunk(
  "yard/getContainerYardTrail", // action string
  async (id: any) => {
    try {
      const res = await ax.get<IApi>(`/get-yard-trail-by-container-num/${id}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const removeVehicleFromYard = createAsyncThunk(
  "yard/removeVehicleFromYard", // action string
  async (formRecord: any) => {
    try {
      const res = await ax.put<IApi>("/remove-yard-row-slot", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
